import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom"
import * as Routes from '../constants/routes'
import {MainContextProvider} from "../context/mainContext";
import { HomePage } from '../pages/home'
import { Popup } from '../components/advanced/popup'
// import { Page } from '../components/basic/layout'
import { AppData } from '../data'

const App = () => {

  return (
    <Router>
      <MainContextProvider>
        <Popup />
          <Switch>
            <Route path={Routes.HOME}>
              <HomePage appData={AppData} />
            </Route>
          </Switch>
      </MainContextProvider>
    </Router>
  )
}

export default App
